// extracted by mini-css-extract-plugin
export default {"hr":"SchedaSpecialeMalaria_hr__aQTCS","mandatoryColor":"SchedaSpecialeMalaria_mandatoryColor__lrwW6","fieldContainer":"SchedaSpecialeMalaria_fieldContainer__poxzW"};